import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import LazyMemberImage from "../components/LazyMemberImage";
import { useGetOutletsForCustomersQuery } from "../slices/OutletSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import { getNameOfTheDay } from "../utils/getCurrentDate";
import Loader from "../components/Loader";
import {
  useRemoveFromFavouritesMutation,
  useUpdateMyDetailsMutation,
} from "../slices/customerSlice";
import { toast } from "react-toastify";

const NearByOutletsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [outletsToList, setOutletsToList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [custLoc, setCustLoc] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const dispatch = useDispatch();
  const [favouriteOutlets, setFavouriteOutlets] = useState([]);
  const [custLongitude, setCustLongitude] = useState(80.15089246560488);
  const [custLatitude, setCustLatitude] = useState(12.92797162225213);
  // let custLongitude = null;
  // let custLatitude = null;
  const setCustomerLocation = async () => {
    let receivedLocation = "https://www.google.com/maps?q=";
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          console.log(new Date().toISOString());
          console.log(latitude + "_" + longitude);
          receivedLocation = receivedLocation + latitude + "," + longitude;
          setCustLatitude(latitude);
          setCustLongitude(longitude);
          setCustLoc(receivedLocation);
          setLocationError(null);
          dispatch(
            setCredentials({
              ...userInfo,
              latitude: latitude,
              longitude: longitude,
            })
          );
          // if (resData) toast.success("Location added successfully");
        },
        (err) => {
          console.error(err);
          setLocationError(err.message);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      console.log("inside location else");
      setLocationError("Geolocation is not supported by your browser.");
    }
  };
  useEffect(() => {
    setCustomerLocation();
  }, []);

  const [outletRadius, setOutletRadius] = useState(5);
  // const [apiQuery, setApiQuery] = useState(
  //   userInfo?.selectedOutletId?.restrictedOutlet
  //     ? `outletGroup=${userInfo?.openedOutletGroup}&operationStatus=true`
  //     : `latitude=${custLatitude}&longitude=${custLongitude}&radius=${outletRadius}&operationStatus=true`
  // );
  const {
    data: outlets,
    isLoading,
    error,
    refetch,
  } = useGetOutletsForCustomersQuery({
    query: userInfo?.selectedOutletId?.restrictedOutlet
      ? `outletGroup=${userInfo?.openedOutletGroup}&operationStatus=true`
      : `latitude=${custLatitude}&longitude=${custLongitude}&radius=${outletRadius}&operationStatus=true`,
  });

  const [addFavourites, { isLoading: addFavouritesLoading }] =
    useUpdateMyDetailsMutation();

  const [remFavourites, { isLoading: remFavouritesLoading }] =
    useRemoveFromFavouritesMutation();

  useEffect(() => {
    if (!isLoading && outlets) {
      setOutletsToList(outlets);
    }
  }, [isLoading, outlets]);

  useEffect(() => {
    if (custLatitude !== null && custLongitude !== null) {
      console.log("inside useEffect : " + custLatitude + " " + custLongitude);

      if (!error && !isLoading) {
        console.log("inside refetch : " + custLatitude + " " + custLongitude);
        refetch();
        setOutletsToList(outlets);
      }
    }
  }, [custLatitude, custLongitude, error, refetch, outlets, isLoading]); // only run this effect when location is updated

  const navigate = useNavigate();

  const handleOutletSelect = (outlet) => {
    dispatch(setCredentials({ ...userInfo, outletsDetails: [outlet] }));
    navigate(`/foodsList/${outlet?._id}`);
  };

  const filteredOutlets = outletsToList?.filter((ot) =>
    ot?.outletName?.toLowerCase()?.includes(searchText?.toLowerCase())
  );

  const toggleFavourite = async (outletId) => {
    const isAlreadyFavourite = userInfo?.favouriteOutlets?.includes(outletId);

    try {
      if (isAlreadyFavourite) {
        await remFavourites({
          favouriteOutletId: outletId,
          token: userInfo.token,
        }).unwrap();

        const updatedFavourites = userInfo.favouriteOutlets.filter(
          (id) => id !== outletId
        );

        dispatch(
          setCredentials({
            ...userInfo,
            favouriteOutlets: updatedFavourites,
          })
        );

        toast.success("Removed from favourites!");
      } else {
        await addFavourites({
          favouriteOutletId: outletId,
          visitorId: userInfo.visitorId,
          token: userInfo.token,
        }).unwrap();

        const updatedFavourites = [
          ...(userInfo.favouriteOutlets || []),
          outletId,
        ];

        dispatch(
          setCredentials({
            ...userInfo,
            favouriteOutlets: updatedFavourites,
          })
        );

        toast.success("Added to favourites!");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update favourites");
    }
  };

  return (
    <>
      <h6 style={{ color: "black" }}>Select Restaurant</h6>

      <Row className="mb-3">
        <Col xs={9}>
          <Form.Control
            type="text"
            placeholder="Search by restaurant name..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="mb-3"
            style={{ lineHeight: "2rem" }}
          />
        </Col>
        <Col xs={3}>
          <Form.Select
            style={{ lineHeight: "2rem" }}
            value={outletRadius}
            onChange={(e) => setOutletRadius(Number(e.target.value))}
          >
            {[5, 10, 15, 20, 30].map((km) => (
              <option key={km} value={km}>
                {km} km
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      {filteredOutlets.map((ot) => (
        <>
          <Row
            key={ot._id}
            className="align-items-center mb-3"
            style={{
              borderBottom: "1px solid #ddd",
              paddingBottom: "0.8rem",
            }}
          >
            {/* Food Image */}
            <Col xs={2}>
              <LazyMemberImage
                foodItemId={ot._id + "outletImage"}
                imageUpdatedTimeFromDB={ot.imageUploadedTime}
                currentlySelling={true}
                photoUploaded={ot.imageUploaded}
              />
            </Col>
            <Col xs={8} onClick={(e) => handleOutletSelect(ot)}>
              <div className="d-flex justify-content-between align-items-center">
                <h6 style={{ color: "rgb(17, 93, 102)" }}>{ot?.outletName} </h6>
                {userInfo?.token && (
                  <Button
                    onClick={(e) => {
                      e.stopPropagation(); // Prevents row click
                      toggleFavourite(ot._id);
                    }}
                    className="btn btn-sm"
                    style={{
                      color: userInfo?.favouriteOutlets?.includes(ot._id)
                        ? "red"
                        : "gray",
                      border: "none",
                      background: "transparent",
                    }}
                  >
                    {userInfo?.favouriteOutlets?.includes(ot._id) ? "♥" : "♡"}
                  </Button>
                )}
              </div>
              {(!(
                Number(new Date().getHours() + "." + new Date().getMinutes()) >=
                  ot?.openingHour &&
                Number(new Date().getHours() + "." + new Date().getMinutes()) <
                  ot?.closingHour
              ) ||
                !ot.openedDays.includes(getNameOfTheDay(new Date().getDay())) ||
                !ot?.currentlyOpen) && (
                <>
                  {" "}
                  <small style={{ color: "grey" }}>Closed Now</small>{" "}
                  <small style={{ color: "grey" }}>
                    - opens at{" "}
                    {ot?.openingHour >= 12
                      ? ot?.openingHour - 12 + " PM"
                      : ot?.openingHour +
                        (ot?.openingHour?.toString()?.split(".")[1]?.length < 2
                          ? "0 AM"
                          : " AM")}
                  </small>
                </>
              )}
            </Col>
            <Col xs={1}>
              {ot?.outletLocation?.coordinates?.length === 2 &&
                ot?.outletLocation?.coordinates[0] > 0 &&
                ot?.outletLocation?.coordinates[1] > 0 && (
                  <a
                    href={`https://www.google.com/maps?q=${ot?.outletLocation?.coordinates[0]}, ${ot?.outletLocation?.coordinates[1]}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaLocationDot
                      style={{
                        color: "orange",
                        width: "1.5rem",
                        height: "1.5rem",
                      }}
                    />
                    <small style={{ fontSize: "0.5rem" }}>location</small>
                  </a>
                )}
            </Col>
          </Row>
        </>
      ))}
    </>
  );
};

export default NearByOutletsScreen;
